import { getOrCreateSessionId } from "./session";

export type ClientEventType = "choice" | "cta_click" | "slide_enter" | "mode_switch";
export type ClientDeviceType = "mobile" | "tablet" | "desktop";

export type ClientEventInput = {
  sectionId: string;
  questionId: string;
  choice: string;
  eventType: ClientEventType;
};

export function detectDeviceType(width = window.innerWidth): ClientDeviceType {
  if (width < 720) return "mobile";
  if (width < 1100) return "tablet";
  return "desktop";
}

export async function recordRoadshowEvent(input: ClientEventInput): Promise<void> {
  try {
    const response = await fetch("/api/events", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        ...input,
        sessionId: getOrCreateSessionId(),
        deviceType: detectDeviceType(),
        referrer: document.referrer || "",
        userAgent: navigator.userAgent || ""
      })
    });
    if (!response.ok) {
      throw new Error(`Roadshow feedback API returned ${response.status}`);
    }
  } catch (error) {
    console.warn("Roadshow feedback event was not recorded", error);
  }
}
